import React from 'react'
import { FormGroupLayoutProps } from './FormGroupLayout';

const FormGroupNoStyling = ({children}: FormGroupLayoutProps) => {
  return <React.Fragment>
    {children}
  </React.Fragment>
}
  
export default FormGroupNoStyling;


